import { render, staticRenderFns } from "./Postgres.vue?vue&type=template&id=f7adee76&"
import script from "./Postgres.vue?vue&type=script&lang=js&"
export * from "./Postgres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports